<template>
    <modal :title="$t('Clients.edit_client_file')" @close-request="$emit('closeModal')" closable>

        <div class="modal-cont">

            <regular-input class="form-group" :value="name" @input="name = $event"
                :placeholder="$t('Clients.enter_name')" />

            <multi-select class="client-select m-b" :options="clients" :selected-options="selectedClients"
                @select="handleClientsSelect" :placeholder="$t('Clients.select_clients')" :multiple="false" />

        </div>
        <div class="btn-div">
            <button class="btn btn-blk btn-cnl" @click="$emit('closeModal')">{{ $t('Clients.cancel') }}</button>
            <button @click="saveClientFiles()" class="btn btn-kne-orange">{{ $t('Clients.save') }}</button>
        </div>
    </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import { db } from '../../../../firebase'
import RegularInput from '../../basic-components/regularInput.vue'
import { MultiSelect } from 'vue-search-select'

export default {
    components: {
        Modal,
        RegularInput,
        MultiSelect
    },
    data () {
        return {
            clients: [],
            name: '',
            clientFileNames: [],
            selectedClients: []
        }
    },
    props: {
        clientFile: Object
    },
    methods: {
        async getClientFiles () {
            await db.ref('database/clientfiles/transporter/').child(this.companyUID).child('/clientfile').once('value', (snapshot) => {
                if (!snapshot.exists()) return
                this.clientFileNames = Object.entries(snapshot.val()).map(([id, data]) => (data.name))
            })
        },
        getClients () {
            db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID).once('value', (snapshot) => {
                if (!snapshot.exists()) return

                Object.entries(snapshot.val()).forEach(([id, user]) => {
                    if (user.status !== 'Approved') return
                    this.clients.push({
                        value: id,
                        text: user.name
                    })
                })
            })
        },
        saveClientFiles () {
            if (!this.name) {
                confirm('Please enter name')
                return
            }

            if (!this.selectedClients.length) {
                confirm('Please select client')
                return
            }

            if (this.clientFileNames.includes(this.name) && this.clientFile.name !== this.name) {
                confirm('Client file name already exists. Please enter a new name')
                return
            }

            const client = this.selectedClients.map(client => client.value)[0]

            db.ref('database/clientfiles/transporter').child(this.companyUID).child('clientfile').child(this.clientFile.id).set(
                {
                    name: this.name,
                    client: client
                }
            ).then(() => {
                console.log('Clientfile saved')
                this.name = ''
                this.$emit('closeModal')
            }).catch(function (error) {
                confirm('Error adding client file')
                console.error(error)
            })
        },
        handleClientsSelect: function (list) {
            if (!list.length) {
                this.selectedClients = []
                return
            }
            if (list.length === 1) {
                this.selectedClients = list
                return
            }
            this.selectedClients = [list[1]]
        }
    },
    async created () {
        await this.getClients()
        this.name = this.clientFile.name
        this.selectedClients = this.clients.filter(client => client.value === this.clientFile.client) || []
        this.getClientFiles()
    },
    computed: {
        companyUID () {
            return this.$store.state.authorization.company
        }
    }
}
</script>

<style scoped>
.btn-div {
    gap: 10px;
    width: 30%;
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
    position: absolute;
    bottom: 0%;
    right: 0%;
    margin-bottom: 30px;
    margin-right: 30px;
}

.btn-div > .btn {
    margin-top: 8px;
}

.btn-blk {
    color: white;
    background-color: black;
}

.modal-cont {
    width: 95%;
    margin: 0 auto;
    margin-top: 20px;
}

.client-select {
    margin-bottom: 15px;
}

.m-b {
  margin-bottom: 25%;
}

@media (max-width: 450px) {
    .m-b {
        margin-bottom: 65%;
    }
}
</style>
